import { createReducer, on } from '@ngrx/store';
import { isSameDay, isValid, startOfDay, startOfToday } from 'date-fns';
import { isNullOrUndefined } from '@mona/shared/utils';
import { setEncounterSelectedDate } from '../actions';

const INITIAL_DATE = startOfToday();

/** Encounter view selected date. Use isSameDay, not getDate(). */
export const selectedDateReducer = createReducer(
    INITIAL_DATE,
    on(setEncounterSelectedDate, (prevDate, { selectedDate }) => {
        if (isNullOrUndefined(selectedDate)) {
            return null;
        }
        if (!isValid(selectedDate) || (prevDate && isSameDay(selectedDate, prevDate))) {
            return prevDate;
        }
        return startOfDay(selectedDate);
    }),
);
